{
  "events": [
    {
      "id": "event-dinner-sarah",
      "title": "Dinner with Sarah",
      "startTime": "2026-07-14T19:00:00-06:00",
      "endTime": "2026-07-14T20:30:00-06:00",
      "timeZone": "America/Denver",
      "organizerId": "person-owner",
      "attendeeIds": ["person-owner", "person-sarah"],
      "revision": 1,
      "etag": "event-dinner-sarah-r1"
    },
    {
      "id": "event-focus-block",
      "title": "Focus block",
      "startTime": "2026-07-15T10:00:00-06:00",
      "endTime": "2026-07-15T11:00:00-06:00",
      "timeZone": "America/Denver",
      "organizerId": "person-owner",
      "attendeeIds": ["person-owner"],
      "revision": 1,
      "etag": "event-focus-block-r1"
    },
    {
      "id": "event-demo-appointment",
      "title": "Bander Demo Appointment",
      "startTime": "2026-07-17T13:00:00-06:00",
      "endTime": "2026-07-17T14:00:00-06:00",
      "timeZone": "America/Denver",
      "organizerId": "person-owner",
      "attendeeIds": ["person-owner"],
      "revision": 1,
      "etag": "event-demo-appointment-r1"
    },
    {
      "id": "event-dentist",
      "title": "Dentist appointment",
      "startTime": "2026-07-23T13:00:00-06:00",
      "endTime": "2026-07-23T14:00:00-06:00",
      "timeZone": "America/Denver",
      "organizerId": "person-owner",
      "attendeeIds": ["person-owner"],
      "revision": 1,
      "etag": "event-dentist-r1"
    }
  ]
}
